<script setup lang="ts">

import { faArrowUpFromBracket, faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterTutors } from '@entities/tutor'
import { FilterDateRange } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelect } from '@shared/ui/selects'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useFiltersDisciplineTasks } from '../model/filters-discipline-tasks.hook'

defineOptions({
  name: 'FiltersDisciplineTasks',
})

const {
  refSearch,
  refTutorIds,
  refDueDateRange,
  refStatuses,
  refTypes,
  statusOptions,
  typeOptions,
  searchMaxLength,
  isLoading,
  isExporting,
  canManageTutorTasks,
  search,
  clearFilters,
  exportTasks,
  openCreateTask,
} = useFiltersDisciplineTasks()
</script>

<template>
  <div class="filters-discipline-tasks">
    <div class="filters-discipline-tasks__fields">
      <AppInput
        v-model="refSearch"
        class="filters-discipline-tasks__search"
        label="Search"
        placeholder="Search"
        :max-length="searchMaxLength"
        :disabled="isLoading"
        @keyup:enter="search"
      />
      <FilterTutors
        v-model="refTutorIds"
        class="filters-discipline-tasks__tutors"
        active
        paid
        with-paid-label
        :disabled="isLoading"
      />
      <FilterDateRange
        v-model="refDueDateRange"
        presets
        class="filters-discipline-tasks__date"
        label="Due date & time"
        placeholder="Search"
        :disabled="isLoading"
      />
      <AppMultiSelect
        v-model="refStatuses"
        class="filters-discipline-tasks__status"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
      <AppMultiSelect
        v-model="refTypes"
        class="filters-discipline-tasks__type"
        :options="typeOptions"
        label="Task type"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
      <BtnPrimary
        text="Search"
        :disabled="isLoading"
        @click="search"
      />
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />
    </div>
    <div class="filters-discipline-tasks__controls">
      <BtnIcon
        :icon="faArrowUpFromBracket"
        title="Export as CSV"
        tooltip-text="Export as CSV"
        :disabled="isExporting"
        @click="exportTasks"
      />
      <BtnPrimary
        v-if="canManageTutorTasks"
        text="Create task"
        color="emerald"
        @click="openCreateTask"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersDisciplineTasks.scss" />
